import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/parametres/notifications')({
  head: () => noIndexRouteHead('settingsNotifications', 'fr'),
  component: () => <SettingsPage section="benachrichtigungen" />,
})
